import Box, { BoxProps } from '@mui/material/Box';

import { paths } from 'src/routes/paths';
import { usePathname } from 'src/routes/hooks';

import { useResponsive } from 'src/hooks/use-responsive';

import { useSettingsContext } from 'src/components/settings';

import AiChatWidget from 'src/sections/ai/ai-chat-widget';
import AiNudgeBanner from 'src/sections/ai/ai-nudge-banner';
import EmailSyncAlert from 'src/sections/app/email-sync-alert';
import PhoneSetupAlert from 'src/sections/app/phone-setup-alert';
import BackgroundTaskManager from 'src/sections/app/background-task-manager';

import { NAV, HEADER } from '../config-layout';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const settings = useSettingsContext();

  const lgUp = useResponsive('up', 'lg');

  const isNavHorizontal = settings.themeLayout === 'horizontal';

  const isNavMini = settings.themeLayout === 'mini';

  const onDashboard = usePathname() === paths.dashboard.root;

  if (isNavHorizontal) {
    return (
      <Box
        component="main"
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: 'column',
          pt: `${HEADER.H_MOBILE + 24}px`,
          pb: 10,
          ...(lgUp && {
            pt: `${HEADER.H_MOBILE * 2 + 40}px`,
            pb: 15,
          }),
        }}
      >
        {children}
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(lgUp && {
          px: 2,
          py: `${HEADER.H_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.W_VERTICAL}px)`,
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI}px)`,
          }),
        }),
        ...sx,
      }}
      {...other}
    >

      <PhoneSetupAlert />
      <EmailSyncAlert />
      <BackgroundTaskManager />
      {/* The dashboard's Today Summary carries the same counts, so the banner would only push the board down (JT1-1830) */}
      {!onDashboard && <AiNudgeBanner />}

      {children}

      <AiChatWidget />
    </Box>
  );
}
